import { io } from "socket.io-client";

//const MRC_DOMAIN = "https://demo.mrcradiology.com";
const MRC_DOMAIN = "https://mrcradiology.com";   //Prod
//const MRC_DOMAIN = "http://localhost";

export const LoginApi = "https://demo.app.dcmcloud.com";

// VIEWER URLs
export const ViewerURL = "https://app.dcmcloud.com";
export const GetTokenApi = "https://app.dcmcloud.com";
export const ClearCacheApi = "https://app.dcmcloud.com";
export const BlockChain = "http://34.203.10.190:4000";

// // PRODUCTION ENV - Private IP
export const WelcomeApi = `${MRC_DOMAIN}/floader/welcome`; // FileLoader
// // // API endpoints
export const FileLoader = `${MRC_DOMAIN}/floader`; // FileLoader
export const UploadApi = `${MRC_DOMAIN}/uploadapi`; // NODE API
export const DRCoreApi = `${MRC_DOMAIN}/drapi`; //DICOM Reader
export const keyImages = `${MRC_DOMAIN}/keydelete`;
export const DownloadApi = `${MRC_DOMAIN}/downloadapi`; // Download API

//DEVELOPMENT ENV - Localhost
//export const WelcomeApi = `${MRC_DOMAIN}:5002/welcome`; // FileLoader
//API endpoints
//export const FileLoader = `${MRC_DOMAIN}:5002`; // FileLoader
//export const UploadApi = `${MRC_DOMAIN}:5004`; // NODE API
//export const DRCoreApi = `${MRC_DOMAIN}:5001`; //DICOM Reader
//export const keyImages = `${MRC_DOMAIN}:8001`; //Keyimages
//export const DownloadApi = `${MRC_DOMAIN}:5016`; //DownloadDicom

export const socket = io(UploadApi);

// Bucket Selection
export const googleBucket = false;
export const awsBucket = true;
